import * as React from 'react'
import { Box, Typography, Button } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

/**
 * Full-screen error display
 * Used when app bootstrap or critical operations fail
 */
export default function ErrorScreen({
    title = 'Something went wrong',
    message = 'An unexpected error occurred',
    onRetry,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 2,
                px: 3,
                textAlign: 'center',
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main' }} />
            <Typography variant="h6" color="error">
                {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {message}
            </Typography>
            {onRetry && (
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onRetry}
                    sx={{ mt: 2 }}
                >
                    Try Again
                </Button>
            )}
        </Box>
    )
}
